import { render, staticRenderFns } from "./NewWantRequest.vue?vue&type=template&id=0be69534&scoped=true&"
import script from "./NewWantRequest.vue?vue&type=script&lang=js&"
export * from "./NewWantRequest.vue?vue&type=script&lang=js&"
import style0 from "./NewWantRequest.vue?vue&type=style&index=0&id=0be69534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be69534",
  null
  
)

export default component.exports